import { render, staticRenderFns } from "./UpdateDirectory.vue?vue&type=template&id=034bd47e"
import script from "./UpdateDirectory.vue?vue&type=script&lang=js"
export * from "./UpdateDirectory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports